export const baseAction = type => `${type}_REQUEST`;
export const successAction = type => `${type}_SUCCESS`;
export const failureAction = type => `${type}_FAILURE`;

export const callApi = (action, actionType, options = {}) => dispatch => {
  dispatch({ type: baseAction(actionType), ...options });

  return new Promise((resolve, reject) => {
    return action()
      .then(payload => {
        dispatch({
          type: successAction(actionType),
          payload,
          ...options,
        });
        resolve(payload);
      })
      .catch(error => {
        dispatch({
          type: failureAction(actionType),
          error,
          ...options,
        });
        reject(error);
      });
  });
};
